import classNames from 'classnames';
import { Children, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Grid } from '../Grid';
import { type ChildAndClassNameProps } from '../types';
import { Body1, Body3 } from '../typography';
import {
  card,
  cardImage,
  cardImagePlaceholder,
  root,
} from './IntegrationsGrid.css';

export const IntegrationsGrid = (props: ChildAndClassNameProps) => {
  const { children, className, ...rest } = props;

  const [limit, setLimit] = useState(18);

  const childrenArray = Children.toArray(children);
  const visibleChildren = childrenArray.slice(0, limit);

  const hasMore = limit < childrenArray.length;
  const loadMore = () => {
    setLimit((prev) => prev + 3);
  };

  return (
    <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
      <Grid className={classNames(root, className)} {...rest}>
        {visibleChildren}
      </Grid>
    </InfiniteScroll>
  );
};

IntegrationsGrid.displayName = 'IntegrationsGrid';

export interface IntegrationsCardProps {
  className?: string;
  href: string;
  imgAlt?: string;
  imgSrc?: string;
  name: string;
  type: string;
}

export const IntegrationsCard = (props: IntegrationsCardProps) => {
  const { className, href, imgAlt, imgSrc, name, type, ...rest } = props;

  return (
    <a href={href} className={classNames(card, className)} {...rest}>
      {imgSrc ? (
        <img alt={imgAlt} src={imgSrc} className={cardImage} />
      ) : (
        <div className={classNames(cardImage, cardImagePlaceholder)} />
      )}
      <div>
        <Body1>{name}</Body1>
        <Body3 variant="secondary">{type}</Body3>
      </div>
    </a>
  );
};

IntegrationsCard.displayName = 'IntegrationsCard';
